import { Role } from "helpers";
import { Loading } from "components";
import { RoleTableDataOptions } from "./components/RoleTableDataOptions";
import { RoleTableDataPermissions } from "./components/RoleTableDataPermissions";
import { RoleTableDataUsers } from "./components/RoleTableDataUsers";
import { RoleTableDataStatus } from "./components/RoleTableDataStatus";
import { useRoleManagementContext } from "context";
import { t } from "i18next";

interface RoleDataProps {
  onEdit: (role: Role) => void;
  onDelete: (role: Role) => void;
}
export const RoleTableData = ({ onEdit, onDelete }: RoleDataProps) => {
  const { data, isLoading, isFetching } = useRoleManagementContext();

  return (
    <>
      {!!data && data.data && data.data.length > 0 ? (
        data.data.map((role, index) => (
          <tr key={index} className="h-[100px] max-h-[100px] break-words border-y text-center">
            <>
              <td className="w-full text-center text-sm">{role.name}</td>
              {role.permissions && role.permissions.length > 0 ? (
                <td className="w-full text-center text-sm">
                  <RoleTableDataPermissions group_permissions={role.permissions} />
                </td>
              ) : (
                <td className="w-full text-center text-sm">N/A</td>
              )}
              <td className="w-full text-center text-sm">
                <RoleTableDataUsers role={role} />
              </td>
              <td className="w-full text-center text-sm">
                <RoleTableDataStatus status={role.status} />
              </td>
              <td className="sticky right-0 z-10 w-[200px] min-w-[200px] bg-white text-center text-sm">
                <RoleTableDataOptions role={role} onEdit={onEdit} onDelete={onDelete} />
              </td>
            </>
          </tr>
        ))
      ) : isFetching ? (
        <tr>
          <td colSpan={6}>
            <Loading absolute className="inset-0" />
          </td>
        </tr>
      ) : (
        <tr>
          <td colSpan={6} className="text-center text-gray-500">
            {t("roleManagement.noRolesAvailable")}
          </td>
        </tr>
      )}

      {(isLoading || isFetching) && (
        <tr>
          <td colSpan={6}>
            <Loading absolute className="inset-0" />
          </td>
        </tr>
      )}
    </>
  );
};
